import 'core-js/es6/map';
import 'core-js/es6/set';
import * as React from "react";
import * as ReactDOM from "react-dom";
import { TopNavComponent } from "../components/TopNavComponent";
import { spWindow } from "../common/spWindow";
import { initializeIcons } from '@uifabric/icons';
import apiService from "../common/apiService";
import { SideBarNav } from "../components/SideBarNav";
import { MobileNav } from "../components/MobileNav";
import constants from '../common/constants';
import 'url-search-params-polyfill';
require("../common/polyFills")

declare var window: spWindow;

const isCustomNavVisible = window.location.href.indexOf('/_layouts/15/') === -1 || window.location.href.indexOf('/_layouts/') === -1;
if (isCustomNavVisible) {
    require("../components/navStyles.scss")
}

const moveSearchPlaceHolder = (defaultEle: HTMLElement, mobileArea: HTMLElement, searchBar: HTMLElement) => {
    if (window.innerWidth <= constants.responsiveWidthThreshold) {
        mobileArea.insertBefore(searchBar, mobileArea.childNodes[0]);
    } else {
        defaultEle.insertBefore(searchBar, defaultEle.childNodes[0]);
    }
}

const dlgParamName = "isdlg";
const topNav = () => {
    if (!isCustomNavVisible) {
        return
    }
    var qs = new URLSearchParams(window.location.search);
    let isDlg = false;
    if (qs) {
        qs.forEach(((v, k, p) => {
            if (k.toLocaleLowerCase() == dlgParamName) {
                isDlg = v == "1";
            }
        }));
    }
    if (isDlg) {
        //do nothing for popups
        console.log("NAV -- FOUND DLG -> do nothing");
        return;
    }
    initializeIcons();
    apiService.getNavigation().then(navResponse => {
        const topNavEle = document.getElementById("DeltaTopNavigation");
        const contentEle = document.getElementById("contentBox")
        const sideNavEle = document.getElementById("DeltaPlaceHolderLeftNavBar");
        const searchBar = document.getElementById("DeltaPlaceHolderSearchArea");
        const mobileArea = document.getElementById("DeltaTopNavigation_mobileClone");
        window.onresize = () => moveSearchPlaceHolder(sideNavEle, mobileArea, searchBar);
        contentEle.insertBefore(topNavEle, contentEle.children[0]);
        const titleRow = document.getElementById("s4-titlerow");
        titleRow.style.backgroundImage = `url("${navResponse.BackgroundImageUrl}")`;
        ReactDOM.render(
            <TopNavComponent {...navResponse} />, topNavEle);
        ReactDOM.render(
            <SideBarNav {...navResponse} />, sideNavEle);
        if (mobileArea) {
            ReactDOM.render(
                <MobileNav {...navResponse} />, mobileArea);
        }
        topNavEle.className += " showKoFiNav"
        sideNavEle.className += " showKoFiNav"
        moveSearchPlaceHolder(sideNavEle, mobileArea, searchBar);
    }).catch((resp) => {
        console.error("Error loading nav", resp);
    });

}

if (!window._spBodyOnLoadCalled) {
    window._spBodyOnLoadFunctionNames.push("initIkkNav");
} else {
    window.ExecuteOrDelayUntilScriptLoaded(topNav, "sp.core.js");
}
window.initIkkNav = function () {
    window.ExecuteOrDelayUntilScriptLoaded(topNav, "sp.core.js");
}